module.exports = __webpack_public_path__ + "static/media/alis12.7e085f0b.jpg";